<div class="layout-row">
  @if (mode === MODE.CREATE) {
    <div class="flex">
      <h2 mat-dialog-title>{{'TASK.CREATE.TITLE' | translate}}</h2>
    </div>
  }
  @if (mode === MODE.EDIT) {
    <div class="flex">
      <h2 mat-dialog-title>{{'TASK.EDIT.TITLE' | translate}} {{task.key}}</h2>
    </div>
  }
  @if (mode === MODE.VIEW) {
    <div class="flex">
      <h2 mat-dialog-title>{{task.key}} - {{task.name}}
        @if (task.reference) {
          <span class="link">
            {{'TASK.REFERENCE.LONG.' + task.reference.substring(0, task.reference.indexOf(':')) | translate}}
            #{{task.reference.substring(task.reference.indexOf(':') + 1, task.reference.indexOf('-'))}}...
            <button mat-icon-button (click)="goToReference()" [matTooltip]="'TASK.REFERENCE.GOTO' | translate">
              <mat-icon>link</mat-icon>
            </button>
          </span>
        }
      </h2>
    </div>
  }
  @if (mode === MODE.VIEW) {
    <div class="actions">
      @if (task.status !== STATUS.COMPLETED && task.status !== STATUS.CANCELLED) {
        <button mat-icon-button (click)="edit()"
          [matTooltip]="'COMMON.BUTTONS.EDIT' | translate">
          <mat-icon>edit</mat-icon>
        </button>
      }
      <button mat-icon-button (click)="close()" [matTooltip]="'COMMON.BUTTONS.CLOSE' | translate">
        <mat-icon>clear</mat-icon>
      </button>
    </div>
  }
</div>

<mat-dialog-content>
  @if (mode === MODE.EDIT || mode === MODE.CREATE) {
    <div class="edit-content layout-row">
      <form [formGroup]="form">
        @if (mode === MODE.EDIT) {
          <mat-form-field>
            <mat-label>{{'TASK.KEY.TITLE' | translate}}</mat-label>
            <input matInput [value]="task.key"/>
          </mat-form-field>
        }
        <mat-form-field>
          <mat-label>{{'TASK.NAME.TITLE' | translate}}</mat-label>
          <input matInput formControlName="name" autocomplete="off"/>
        </mat-form-field>
        @if (mode === MODE.CREATE) {
          <mat-form-field>
            <mat-label>{{'TASK.ASSIGNEE.TITLE' | translate}}</mat-label>
            <mat-select formControlName="assignee">
              @for (member of data.organisationMembers | keyvalue; track member) {
                <mat-option [value]="member.value.userid">
                  <div class="option-wrapper">
                    <img alt="User" class="center" fsAvatar [profileId]="member.value.userid" [size]="25"/>
                    <span [class.has-username]="member.value.username != null" [attr.data-email]="member.value.email">
                      {{member.value.username || member.value.email}}
                    </span>
                  </div>
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        }
        <mat-form-field>
          <mat-label>{{'TASK.DUEDATE.TITLE' | translate}}</mat-label>
          <input matInput [matDatepicker]="picker" readonly [min]="dueDateMin" (focus)="picker.open()" autocomplete="off"
            formControlName="dueDate"/>
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker [disabled]="false"></mat-datepicker>
          </mat-form-field>
          <mat-form-field>
            <mat-label>{{'TASK.DESCRIPTION.TITLE' | translate}}</mat-label>
            <textarea matInput formControlName="description" rows="5"></textarea>
          </mat-form-field>
        </form>
      </div>
    } @else {
      <div class="detail-content layout-row">
        <div class="body">
          <div class="label">{{'TASK.DESCRIPTION.TITLE' | translate}}</div>
          <div>
            @if (task.description) {
              <div class="description">{{task.description}}</div>
            } @else {
              <div class="description">{{'TASK.DESCRIPTION.EMPTY' | translate}}</div>
            }
          </div>
          <div class="label">{{'TASK.COMMENT.TITLE' | translate}}</div>
          @if (task.comments?.length === 0) {
            <div class="no-comment">
              {{'TASK.COMMENT.EMPTY' | translate}}
            </div>
          }
          @for (comment of task.comments; track comment) {
            <div class="comment">
              <div class="info layout-row">
                <fs-organisation-member [member]="data.organisationMembers[comment.author]"
                [dense]="true"></fs-organisation-member>
                <span class="date">
                  {{'TASK.COMMENT.DATE_PREFIX' | translate}} {{comment.creationDate > 0 ? (comment.creationDate | date:'medium') : '-'}}
                </span>
              </div>
              <div class="message">{{comment.message}}</div>
            </div>
          }
          <form class="comment-form">
            <mat-form-field [appearance]="showCommentForm ? 'fill' : 'outline'">
              <mat-label>{{'TASK.COMMENT.ADD' | translate}}</mat-label>
              <textarea matInput [formControl]="message" (focus)="toggleComment()"
              [rows]="showCommentForm ? 5 : 1"></textarea>
            </mat-form-field>
            @if (showCommentForm) {
              <button mat-button type="submit" (click)="addComment()" [disabled]="message.disabled">
                {{'COMMON.BUTTONS.ADD' | translate}}
              </button>
              <button mat-button type="button" (click)="toggleComment()" [disabled]="message.disabled">
                {{'COMMON.BUTTONS.CANCEL' | translate}}
              </button>
            }
          </form>
        </div>
        <div class="infos">
          <div class="label">{{'TASK.INFOS.STATE' | translate}}</div>
          <div class="info">
            <fs-task-status [status]="task.status"></fs-task-status>
          </div>
          @if (task.status === STATUS.CANCELLED || task.status === STATUS.COMPLETED) {
            <div class="label">
              {{'TASK.INFOS.' + (task.status === STATUS.COMPLETED ? 'COMPLETED' : 'CANCELLED') | translate}}
            </div>
            <div class="info">{{task.completeDate > 0 ? (task.completeDate | date:'medium') : '-'}}</div>
          } @else {
            <div class="label">{{'TASK.INFOS.EXPIRATION.LABEL' | translate}}</div>
            <div class="info">
              @if (dueDateDuration.days() < 0) {
                <span class="expired">{{task.dueDate > 0 ? (task.dueDate | date:'fullDate') : '-'}} <br/>
                  <em>({{'TASK.INFOS.EXPIRATION.SINCE' | translate}} {{dueDateDuration | amDuration:'days' }})</em>
                </span>
              }
              @if (dueDateDuration.days() === 0) {
                <span class="today">{{task.dueDate > 0 ? (task.dueDate | date:'fullDate') : '-'}} <br/>
                  <em>({{'TASK.INFOS.EXPIRATION.TODAY' | translate}})</em>
                </span>
              }
              @if (dueDateDuration.days() > 0) {
                <span>{{task.dueDate > 0 ? (task.dueDate | date:'fullDate') : '-'}} <br/>
                  <em>({{'TASK.INFOS.EXPIRATION.IN' | translate}} {{dueDateDuration | amDuration:'days' }})</em>
                </span>
              }
            </div>
          }
          <div class="label">{{'TASK.INFOS.ASSIGNEE' | translate}}</div>
          <div class="info">
            <fs-organisation-member [member]="data.organisationMembers[task.assignee]"
            [dense]="true"></fs-organisation-member>
          </div>
          <div>
            <div class="label">{{'TASK.INFOS.AUTHOR' | translate}}</div>
            <div class="info">
              <fs-organisation-member [member]="data.organisationMembers[task.author]"
              [dense]="true"></fs-organisation-member>
            </div>
            @if (task.followers.length > 0) {
              <div>
                <div class="label">{{'TASK.INFOS.OBSERVERS' | translate}}</div>
                @for (follower of task.followers; track follower) {
                  <div class="info">
                    <fs-organisation-member [member]="data.organisationMembers[follower]"
                    [dense]="true"></fs-organisation-member>
                  </div>
                }
              </div>
            }
            <div class="infosmall">
              {{'TASK.INFOS.CREATED' | translate}} {{task.creationDate > 0 ? (task.creationDate | date:'medium') : '-'}}<br>
              {{'TASK.INFOS.MODIFIED' | translate}} {{task.modificationDate > 0 ? (task.modificationDate | date:'medium') : '-'}}
            </div>
          </div>
        </div>
      </div>
    }
  </mat-dialog-content>

  @if (mode === MODE.EDIT || mode === MODE.CREATE) {
    <mat-dialog-actions class="btn-uppercase align-right">
      <button mat-button color="primary" (click)="cancel()">
        {{'COMMON.BUTTONS.CANCEL' | translate}}
      </button>
      @if (mode === MODE.EDIT) {
        <button mat-button color="primary" (click)="update()" [disabled]="form.invalid">
          {{'COMMON.BUTTONS.SUBMIT' | translate}}
        </button>
      }
      @if (mode === MODE.CREATE) {
        <button mat-button color="primary" (click)="create()" [disabled]="form.invalid">
          {{'COMMON.BUTTONS.CREATE' | translate}}
        </button>
      }
    </mat-dialog-actions>
  }
